export default __webpack_public_path__ + "static/media/Mark-3-Blueprints-02.1a7f1e9c.jpg";